<template lang="pug">
  section.faq#faq(v-lazyload)
    .container
      h2.section-title.section-title_white
        span {{ $t('faq.title') }}
      FaqCategories
</template>

<script>
import inViewport from '@/helpers/inViewport'
import { mapActions, mapState } from 'vuex'
import FaqCategories from '@/components/faq/FaqCategories'

export default {
  name: 'Faq',
  components: {
    FaqCategories
  },
  computed: {
    ...mapState('siteVersions', {
      currentCountry: state => state.item
    })
  },
  watch: {
    currentCountry () {
      this.$nextTick(() => {
        inViewport(this.$el, this.fetch, 'offset')
      })
    }
  },
  methods: {
    ...mapActions('faqs', ['fetch'])
  }
}
</script>
